import { render, staticRenderFns } from "./AsideBar.vue?vue&type=template&id=4021f7ad&"
import script from "./AsideBar.vue?vue&type=script&lang=js&"
export * from "./AsideBar.vue?vue&type=script&lang=js&"
import style0 from "./AsideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports